import { render, staticRenderFns } from "./ImageSwipe.vue?vue&type=template&id=691d0824"
import script from "./ImageSwipe.vue?vue&type=script&lang=js"
export * from "./ImageSwipe.vue?vue&type=script&lang=js"
import style0 from "./ImageSwipe.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports